<template>
    <div>
        <v-app-bar app color="white" class="codettes-nav" elevation="2">
            <v-app-bar-nav-icon aria-label="Open navigation menu" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-img alt="Codettes" src='@/assets/img/logo/logo_full.svg' max-width='190px'/>
                <v-tabs align-with-title background-color="transparent"
                        v-model="activeTab" class="d-none d-sm-flex ml-6">
                    <v-tab
                            v-for="tab in links"
                            :key="tab.title"
                            color="#CE128A"
                            @click="navigate(tab.link)"
                    >
                        {{ tab.title }}
                    </v-tab>
                </v-tabs>
        </v-app-bar>

        <v-navigation-drawer
                v-model="drawer"
                fixed
                temporary
                class="d-flex"
        >
            <v-list
                    nav
                    dense
            >
                <v-list-item v-for="(item, index) in links" :key="index" @click="navigate(item.link)">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>

    export default {
        name: "NavigationBar",
        data: () => ({
            drawer: false,
            activeTab: null,
            links: [
                {
                    title: 'Home',
                    link: 'Home',
                    icon: 'fas fa-home'
                },
                {
                    title: 'Impact',
                    link: 'Impact',
                    icon: 'fas fa-chart-line'
                },
                {
                    title: 'News',
                    link: 'News',
                    icon: 'far fa-newspaper'
                },
                {
                    title: 'Activities',
                    link: 'Activities',
                    icon: 'fas fa-user-hard-hat'
                },
                {
                    title: 'About',
                    link: 'About',
                    icon: 'fas fa-user-astronaut'
                },
                {
                    title: 'Portfolio',
                    link: 'Portfolio',
                    icon: 'fad fa-file-chart-pie'
                },
                {
                    title: 'Sponsors',
                    link: 'Sponsors',
                    icon: 'far fa-newspaper'
                },
                {
                    title: 'Contact',
                    link: 'Contact',
                    icon: 'fas fa-envelope'
                },
            ]
        }),
        methods: {
            navigate(section) {
                this.$vuetify.goTo('#' + section, { offset: 72 })
                this.drawer = false
            },
            updateActiveTab() {
                const threshold = 120
                let current = 0
                this.links.forEach((item, index) => {
                    const section = document.getElementById(item.link)
                    if (section && section.getBoundingClientRect().top <= threshold) current = index
                })
                this.activeTab = current
            },
            openPrivacyDialog() {
                this.$store.dispatch('openPrivacyDialog')
            },
            openDisclaimerDialog() {
                this.$store.dispatch('openDisclaimerDialog')
            }
        },
        mounted() {
            window.addEventListener('scroll', this.updateActiveTab, {passive: true})
            this.updateActiveTab()
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.updateActiveTab)
        }
    }
</script>

<style scoped>
.codettes-nav {
    border-bottom: 3px solid #ce128a;
}
</style>
